// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
    Typography,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    Link,
} from '@material-ui/core';
import Image from '../../components/image';
import Assets from '../../assets';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import NoSearchResult from '../../components/search/noresult-search';
import './style.css';

function Binder(props) {
    const { Content, Tabclick, searchText } = props;

    const isRender = (title, searchText) => {
        if (searchText) {
            return searchText.toLowerCase() === title.toLowerCase() || searchText.toLowerCase().includes(title.toLowerCase()) || title.toLowerCase().includes(searchText.toLowerCase());
        }
        return true;
    };

    const isRenderTitle = (list, searchText) => {
        if (searchText) {
          return list.some((row) => isRender(row.Title, searchText));
        }
        return true;
    };

    return (<>
        {isRenderTitle(Content.Binder, searchText) ? (
        <Grid container className="apibinder-section">
            <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                {Tabclick ? null : (
                    <Typography component="h3">Binder</Typography>
                )}
            </Grid>
            <Grid container spacing={1}>
                {Content.Binder.map((row, index) => (
                <>
                  {isRender(row.Title, searchText) ? (
                    <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                        <Typography
                            component="div"
                            className="apiproduct-content"
                        >
                            <List>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Image
                                            src={Assets.Icons.Bolt.Path}
                                            alt={Assets.Icons.Bolt.Alt}
                                            className="apiproduct-img"
                                        />
                                    </ListItemAvatar>
                                    <Typography component="h4">
                                        {row.Title}
                                    </Typography>
                                </ListItem>
                            </List>
                            <Typography component="span">
                                {row.Line1}
                            </Typography>

                            <Typography
                                component="p"
                                dangerouslySetInnerHTML={{
                                    __html: row.Content,
                                }}
                            ></Typography>
                            <Typography
                                component="div"
                                className="apiproduct-tryit"
                            >
                                <Typography
                                    component="div"
                                    className="apiproduct-ac-btn"
                                >
                                    <ArrowRightAltIcon />
                                    <Link
                                        component={RouterLink}
                                        to={`/try-api/${row.TryAPI.Link}/2`}
                                    >
                                        Try it Now
                                    </Link>
                                </Typography>
                                <Typography
                                    component="div"
                                    className="apiproduct-ac-btn"
                                >
                                    <ArrowRightAltIcon />
                                    <Link
                                        component={RouterLink}
                                        to={{
                                            pathname: `/docs-api/${row.URL.toLowerCase()}/2`,
                                            search: null,
                                            state: { page: row.URL },
                                        }}
                                    >
                                        {row.link}
                                    </Link>
                                </Typography>
                            </Typography>
                        </Typography>
                    </Grid>
                  ) : (' ')}
                </>
                ))}
            </Grid>
        </Grid>
        ) : (
            <div className="nosearch">
                {Tabclick ? <NoSearchResult /> : null}
            </div>
        )}
    </>);
}

Binder.propTypes = {
    Content: PropTypes.object.isRequired,
    keys: PropTypes.array,
};

export default Binder;
